module.exports = __webpack_public_path__ + "Group 15718.e3d5ed34595996113773.png";